exports.f = require('./_wks');



//////////////////
// WEBPACK FOOTER
// /Users/gebb/Desktop/live/~/core-js/library/modules/_wks-ext.js
// module id = 52
// module chunks = 0